import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import toast from 'react-hot-toast';
import { gstAPI, gstSetToken } from '../../services/api';
import { msg } from './gstUi';

export default function GstLockScreen({ phase, onUnlocked, onReset }) {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [mode, setMode] = useState(phase === 'setup' ? 'setup' : 'unlock'); // setup | unlock | reset
  const [loginPw, setLoginPw] = useState('');
  const [busy, setBusy] = useState(false);

  const unlock = async (password) => {
    const r = await gstAPI.unlock(password);
    gstSetToken(r.data.data.token);
    onUnlocked();
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === 'setup') {
        if (pw !== pw2) { toast.error('Passwords do not match'); return; }
        await gstAPI.setPassword(pw);
        await unlock(pw);
      } else if (mode === 'reset') {
        if (pw !== pw2) { toast.error('Passwords do not match'); return; }
        await gstAPI.resetPassword(loginPw, pw);
        toast.success('GST password changed');
        setMode('unlock'); setPw(''); setPw2(''); setLoginPw('');
        onReset();
      } else {
        await unlock(pw);
      }
    } catch (err) {
      toast.error(msg(err));
      if (mode === 'unlock') setPw('');
    } finally {
      setBusy(false);
    }
  };

  const title = mode === 'setup' ? 'Set a GST password' : mode === 'reset' ? 'Reset GST password' : 'GST Billing is locked';
  return (
    <div className="card" style={{ maxWidth: 420, margin: '60px auto', padding: 24 }}>
      <div style={{ textAlign: 'center', marginBottom: 16 }}>
        <Lock size={36} />
        <h2 style={{ margin: '8px 0 0' }}>{title}</h2>
        <p style={{ opacity: 0.7, fontSize: 13 }}>
          {mode === 'setup' ? 'This section has its own password, separate from your login. Minimum 8 characters.'
            : mode === 'reset' ? 'Confirm with your admin login password, then choose a new GST password.'
              : 'Enter the GST password to continue.'}
        </p>
      </div>
      <form onSubmit={submit} autoComplete="off">
        {mode === 'reset' && (
          <div className="form-group">
            <label className="form-label">Your admin login password</label>
            <input className="form-control" type="password" value={loginPw} onChange={(e) => setLoginPw(e.target.value)} autoComplete="current-password" />
          </div>
        )}
        <div className="form-group">
          <label className="form-label">{mode === 'unlock' ? 'GST password' : 'New GST password'}</label>
          <input className="form-control" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoFocus autoComplete="new-password" />
        </div>
        {mode !== 'unlock' && (
          <div className="form-group">
            <label className="form-label">Repeat password</label>
            <input className="form-control" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" />
          </div>
        )}
        <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy || !pw}>
          {busy ? 'Please wait…' : mode === 'setup' ? 'Set password & open' : mode === 'reset' ? 'Change password' : 'Unlock'}
        </button>
      </form>
      {mode !== 'setup' && (
        <p style={{ textAlign: 'center', marginTop: 12, fontSize: 13 }}>
          <button type="button" className="btn btn-secondary" onClick={() => { setMode(mode === 'reset' ? 'unlock' : 'reset'); setPw(''); setPw2(''); }}>
            {mode === 'reset' ? 'Back' : 'Forgot password?'}
          </button>
        </p>
      )}
    </div>
  );
}
